import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Button, Icon } from "@/comn/components";
import { useLogin } from "../../authentication/useLogin";
import { DevAccountButton } from "../../authentication/DevAccounts";
import { DEV_ACCOUNT_TANCIS, DEV_ACCOUNT_TANOGA } from "./Dev_Accounts";
import { _TEST1234 } from "../../config/ApiConfig";
import { DEV_ACCOUNT_TANESW } from "../../authentication/Dev_Accounts_ESW";
import { useAuth } from "@/comn/hooks";
import { useEffect } from "react";
import { InputPassword } from "@/comn/components/_";

export const LoginForm = (props: any) => {
    const navigate = useNavigate();
    const {
        loginForm: { id, pwd, lcm, type, coTpList, coCd, cstmCd, usrCstmList, loading, remoteId, rmtAcrdtActlUsrNm, rmtAcrdtAprchRsn },
        setLoginForm,
        handleSubmitLogin,
        handleSubmitCustom,
        handleSubmitCompany,
        reset,
    } = useLogin();

    const handleChangeId = (event: any) => {
        setLoginForm((prev) => ({ ...prev, id: event.target.value.toUpperCase() }));
    };

    const handleChangeRemoteId = (event: any) => {
        setLoginForm((prev) => ({ ...prev, remoteId: event.target.value.toUpperCase() }));
    };
    const handleChangePassword = (event: any) => {
        setLoginForm((prev) => ({ ...prev, pwd: event }));
    };
    const handleChangeRmtAcrdtAprchRsn = (event: any) => {
        setLoginForm((prev) => ({ ...prev, rmtAcrdtAprchRsn: event.target.value }));
    };
    const handleChangeRmtAcrdtActlUsrNm = (event: any) => {
        setLoginForm((prev) => ({ ...prev, rmtAcrdtActlUsrNm: event.target.value }));
    };
    const handleClickRegistration = () => {
        switch (_TEST1234.SYSTEM_GROUP_ORI) {
            case "tancis":
                window.location.href =
                    window.location.origin + "/ptli/acrdt/newusr/ptli0205001s/intUsrRgst?menuId=menu_ptli0002";
                break;
            case "tanesw":
                window.location.href = window.location.origin + "/registration";
                break;
            case "tanoga":
                window.location.href = window.location.origin + "/ptlo/acrdt/usr/ptlo0201001s?menuId=menu_ptlo0035";
                break;
        }
    };
    const handleClickFind = () => {
        reset();
        navigate(`/findId`);
    };

    // ESW only
    const toggleLicense = (event: any) => {
        setLoginForm((prev) => ({ ...prev, lcm: event.target.checked }));
    };
    // ESW only
    const handleChangeCompany = (event: any) => {
        const co = coTpList.find(({ coDclaCd }: any) => {
            return coDclaCd === event.target.value;
        });
        if (!co) return;
        setLoginForm((prev) => ({ ...prev, coTin: co.coTin, coTpCd: co.coDclaTp, coCd: co.coDclaCd }));
    };

    const handleChangeCustom = (event: any) => {
        if (usrCstmList.findIndex((item) => item.cstmCd === event.target.value) === -1) return;
        setLoginForm((prev) => ({ ...prev, cstmCd: event.target.value }));
    };

    useEffect(() => {
        if (props?.remote === true) {
            setLoginForm((prev) => ({ ...prev, remoteLogin: true }));
        }
    }, []);

    return (
        <>
            {/* Blocking while loading */}
            {loading && (
                <div className="fixed top-0 left-0 w-screen h-screen transition-colors bg-gray/5 z-[999999]">
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary">
                        <Icon icon="loading" className="animate-spin" />
                    </div>
                </div>
            )}

            <div className={classNames("flex flex-col bg-white px-20 py-12 dark:bg-background", "sm:p-8")}>
                {type === "login" ? (
                    <form className="flex flex-col gap-[40px] w-full" onSubmit={handleSubmitLogin}>
                        <fieldset className="flex flex-col gap-3">
                            <div className="flex flex-col gap-3">
                                {_TEST1234.SYSTEM_GROUP_ORI === "tanesw" && (
                                    <div className="h-12 rounded border border-blue flex items-center px-[16px] gap-1 text-blue">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                hidden
                                                className="peer"
                                                type="checkbox"
                                                title="check for remember user information"
                                                checked={lcm}
                                                onChange={toggleLicense}
                                            />
                                            <div className="border rounded-full border-blue w-4 h-4 flex items-center justify-center [&_*]:peer-checked:block">
                                                <Icon className="hidden" icon="check" size="xs" />
                                            </div>
                                            License applicants, please select.
                                        </label>
                                    </div>
                                )}
                                {props?.remote === true ? (
                                    <>
                                        <input
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Admin Id *"
                                            title="Admin ID"
                                            value={remoteId}
                                            onChange={handleChangeRemoteId}
                                        />
                                        {/* <input
                                            type="password"
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Admin Password *"
                                            title="Admin password"
                                            value={pwd}
                                            onChange={handleChangePassword}
                                        /> */}
                                        <InputPassword
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Admin Password *"
                                            value={pwd}
                                            onChange={handleChangePassword}
                                        />
                                        <input
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Login Id *"
                                            title="Login ID"
                                            value={id}
                                            onChange={handleChangeId}
                                        />
                                        <input
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Actual Admin User Name *"
                                            title="Actual User Name"
                                            value={rmtAcrdtActlUsrNm}
                                            onChange={handleChangeRmtAcrdtActlUsrNm}
                                        />
                                        <textarea
                                            className="h-24 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Remote Approach Reason *"
                                            title="Remote Approach Reason"
                                            value={rmtAcrdtAprchRsn}
                                            onChange={handleChangeRmtAcrdtAprchRsn}
                                            maxLength={1000}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <input
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Id *"
                                            title="ID"
                                            value={id}
                                            onChange={handleChangeId}
                                        />
                                        {/* <input
                                            type="password"
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Password *"
                                            title="password"
                                            value={pwd}
                                            onChange={handleChangePassword}
                                        /> */}
                                        <InputPassword
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Password *"
                                            value={pwd}
                                            onChange={handleChangePassword}
                                        />
                                    </>
                                )}
                            </div>
                            <div className="flex gap-1">
                                <input id="saveUserInfo" type="checkbox" title="check for remember user information" />
                                <label htmlFor="saveUserInfo">Remember me</label>
                            </div>
                        </fieldset>
                        <div className="flex flex-col items-center gap-3">
                            <button
                                className={classNames(
                                    "border h-12 w-full bg-primary rounded-[5px] text-primary-contrast transition-colors hover:bg-primary/80",
                                    loading && "bg-primary/50",
                                )}
                                type="submit"
                            >
                                LOGIN
                            </button>
                            {props?.remote !== true && (
                                <>
                                    <button
                                        className="border h-12 w-full border-primary rounded-[5px] text-primary-text transition-colors hover:bg-primary/10"
                                        type="button"
                                        onClick={handleClickRegistration}
                                    >
                                        USER REGISTRATION
                                    </button>

                                    <div className="flex flex-col items-center gap-1">
                                        <Button variant="underlined" width="full" onClick={handleClickFind}>
                                            Forgot your ID or Password?
                                        </Button>
                                        <DevAccountButton
                                            DEV_ACCOUNT={
                                                _TEST1234.SYSTEM_GROUP_ORI === "tancis"
                                                    ? DEV_ACCOUNT_TANCIS
                                                    : _TEST1234.SYSTEM_GROUP_ORI === "tanoga"
                                                      ? DEV_ACCOUNT_TANOGA
                                                      : DEV_ACCOUNT_TANESW
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                ) : type === "company" ? (
                    <form className="flex flex-col gap-[40px] w-full" onSubmit={handleSubmitCompany}>
                        <div className="relative flex w-full items-center">
                            <select
                                className="h-12 input rounded-[5px] px-4 w-full aria-[invalid=true]:border-error appearance-none"
                                value={coCd}
                                onChange={handleChangeCompany}
                            >
                                <option value="">Select Company Code</option>
                                {coTpList?.map(({ coDclaCd, coDclaCdNm }: any) => {
                                    return (
                                        <option key={coDclaCd} value={coDclaCd}>
                                            [{coDclaCd}] {coDclaCdNm}
                                        </option>
                                    );
                                })}
                            </select>
                            <Icon icon="down" size="sm" className="absolute right-[10px] pointer-events-none" />
                        </div>
                        <button
                            className={classNames(
                                "border h-12 w-full bg-primary rounded-[5px] text-white transition-colors hover:bg-primary/80",
                                loading && "bg-primary/50",
                            )}
                            type="submit"
                        >
                            Confirm
                        </button>
                    </form>
                ) : type === "custom" ? (
                    <form className="flex flex-col gap-[40px] w-full" onSubmit={handleSubmitCustom}>
                        <div className="relative flex w-full items-center">
                            <select
                                className="h-12 input rounded-[5px] px-4 w-full aria-[invalid=true]:border-error appearance-none"
                                value={cstmCd}
                                onChange={handleChangeCustom}
                            >
                                <option value="">Custom Office Code</option>
                                {usrCstmList?.map(({ cstmCd, cstmNm }: any) => {
                                    return (
                                        <option key={cstmCd} value={cstmCd}>
                                            {cstmNm}
                                        </option>
                                    );
                                })}
                            </select>
                            <Icon icon="down" size="sm" className="absolute right-[10px] pointer-events-none" />
                        </div>
                        <button
                            className={classNames(
                                "border h-12 w-full bg-primary rounded-[5px] text-white transition-colors hover:bg-primary/80",
                                loading && "bg-primary/50",
                            )}
                            type="submit"
                        >
                            Confirm
                        </button>
                    </form>
                ) : null}
            </div>
        </>
    );
};
